export const WEB_VERSION = 'v1.2.0';
